import { Component, OnInit, OnDestroy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ProductionTranslationService, Language } from '../core/services/production-translation.service';
import { Subscription } from 'rxjs';
import { APP_VERSION } from '../environments/version';
import {
  BEFRET_FACEBOOK_URL,
  BEFRET_INSTAGRAM_URL,
  BEFRET_SUPPORT_EMAIL,
  BEFRET_SUPPORT_PHONE_DISPLAY,
  BEFRET_SUPPORT_PHONE_TEL,
} from '../core/config/contact.config';

import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css',
    standalone: true,
    imports: [RouterModule, SharedModule]
})
export class FooterComponent implements OnInit, OnDestroy {
  /**
   * #1768 — le numéro publié vient de la source unique, jamais du template.
   * `supportPhoneTel` est le MÊME numéro au format `tel:` ; les deux se
   * déduisent l'un de l'autre (cf. `contact.config.spec.ts`).
   */
  readonly supportPhone = BEFRET_SUPPORT_PHONE_DISPLAY;
  readonly supportPhoneTel = BEFRET_SUPPORT_PHONE_TEL;

  currentLanguage: string = 'fr';
  appVersion = APP_VERSION;

  /** #1562 — l'adresse publiée vient de la source unique, jamais du template. */
  readonly supportEmail = BEFRET_SUPPORT_EMAIL;

  /** #2186 — les réseaux sociaux viennent de la source unique, jamais du template. */
  readonly facebookUrl = BEFRET_FACEBOOK_URL;
  readonly instagramUrl = BEFRET_INSTAGRAM_URL;
  private languageSubscription: Subscription = new Subscription();

  constructor(
    private translationService: ProductionTranslationService,
    private viewportScroller: ViewportScroller
  ) {}

  ngOnInit() {
    this.languageSubscription = this.translationService.currentLanguage$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );
  }

  ngOnDestroy() {
    this.languageSubscription.unsubscribe();
  }

  setLanguage(language: string) {
    this.translationService.changeLanguage(language).subscribe(
      () => {
        console.log(`Language changed to ${language}`);
      },
      (error: any) => {
        console.error('Error changing language:', error);
      }
    );
  }

  getSupportedLanguages(): Language[] {
    return this.translationService.getSupportedLanguages();
  }

  scrollToTop(): void {
    console.log('🔝 Scroll to top clicked!');

    // Essayer plusieurs méthodes pour être sûr que ça fonctionne
    this.viewportScroller.scrollToPosition([0, 0]);
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Scroller aussi le document et le body
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Si Angular utilise un router-outlet avec scroll
    const routerOutlet = document.querySelector('router-outlet')?.parentElement;
    if (routerOutlet) {
      routerOutlet.scrollTop = 0;
    }

    console.log('✅ Scroll commands executed');
  }
}

